<template>
  <div class="uploader">
    <img
      class="uploader__art"
      src="/img/undraw/undraw_filing_system_b5d2.svg"
      alt=""
      aria-hidden="true"
    />
    <p class="uploader__title">Hochladen Ihres Fahrplans per Drag & Drop!</p>
    <p
      class="uploader__text"
    >Erstellen Sie einen neuen oder ändern Sie einen bereits bestehenden Fahrplan (.zip oder .xlsx).</p>
    <file-pond
      allow-multiple="false"
      :server="server"
      :labelIdle="labelIdle"
      :labelFileProcessingError="labelFileProcessingError"
      :labelTapToUndo="labelTapToUndo"
    />
    <p class="uploader__hint">
      Eine Anleitung zum Aufbau und Hochladen Ihres Fahrplans, sowie eine Excel Vorlage finden Sie in unserer
      <a
        class="app-textlink"
        href="https://bconn.atlassian.net/wiki/spaces/Kundendokumentation/pages/491547/30.40.30%2BFahrpl%2Bne"
        target="_blank"
        rel="noopener noreferrer"
      >Dokumentation</a>.
    </p>
  </div>
</template>

<script>
// Import Vue FilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import axios from "axios";

export default {
  name: "app",
  data: function() {
    return {
      labelFileProcessingError: error => {
        return error.message;
      },
      labelTapToUndo: "tap to clear",
      labelIdle:
        'Hochladen per Drag & Drop oder <span class="filepond--label-action"> Computer durchsuchen </span>',
      server: {
        process: async (
          fieldName,
          file,
          metadata,
          load,
          error
          // progress,
          // abort
        ) => {
          try {
            const uploadInfo = (
              await axios.post(
                `${this.$store.state.baseUrl}version?fileType=${file.name
                  .split(".")
                  .pop()}`
              )
            ).data;
            await axios
              .create()
              .put(uploadInfo.uploadUrl, file);
            load(uploadInfo.key);
          } catch (e) {
            error(e);
          }
        }
      }
    };
  },
  methods: {},
  components: {
    "file-pond": vueFilePond()
  }
};
</script>

<style scoped>
.uploader {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
}
/* Illustration klein und ohne Orange (Orange bleibt Ort, Primärknopf und aktuellem Wert vorbehalten) */
.uploader__art {
  display: block;
  height: 96px;
  width: auto;
  max-width: 100%;
  margin: 4px auto 12px;
  filter: grayscale(1);
}
.uploader__title {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
  color: var(--ink);
}
.uploader__text {
  margin: 4px 0 16px;
  font-size: 13px;
  line-height: 20px;
  color: var(--ink-3);
}
.uploader__hint {
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}

/* FilePond neutral statt grüner Fläche: Ablagefläche wie Kopfstreifen, Dateizeilen grau, Fehler rot; Schrift der
   Dateizeilen weiß wie bei FilePond (Dunkelmodus siehe unten) */
.uploader ::v-deep .filepond--root {
  margin-bottom: 0;
}
.uploader ::v-deep .filepond--panel-root {
  background-color: var(--band);
}
.uploader ::v-deep .filepond--drop-label {
  color: var(--ink-2);
}
.uploader ::v-deep .filepond--drop-label label {
  font-size: 13px;
  line-height: 20px;
}
.uploader ::v-deep .filepond--label-action {
  color: var(--link);
  text-decoration-color: currentColor;
}
.uploader ::v-deep .filepond--item-panel {
  background-color: var(--ink-3);
}
.uploader ::v-deep [data-filepond-item-state="processing-complete"] .filepond--item-panel {
  background-color: var(--ink-2);
}
.uploader ::v-deep [data-filepond-item-state*="error"] .filepond--item-panel,
.uploader ::v-deep [data-filepond-item-state*="invalid"] .filepond--item-panel {
  background-color: var(--red);
}

/* Dunkelmodus:
   - Illustration gedämpft, damit die weißen Flächen nicht grell wirken.
   - Dateizeilen dunkel statt heller Pillen (die Umkehr der hellen Zeilen ergäbe die hellsten Flächen der Seite; wie
     Tooltip und Storno-Marke bleibt es dunkel): wartet bzw. lädt --here, fertig --sel, Fehler --red-t mit Schrift
     --ink (11,3 bzw. 11,5:1), bei Fehler --red (6,0:1). Knöpfe (FilePonds dunkler Kreis) und Fortschrittsring bleiben
     weiß (14:1 und mehr).
   - Unterzeilen (Größe, „tap to …“) mit 80 statt 50 % Deckkraft (7,9:1 statt 4,0:1), bei Fehler deckend (6,0:1; mit
     80 % wären es 4,4:1). FilePond 4.13 blendet Unterzeilen nach dem Hochladen teils ganz aus (Deckkraft 0); die Regeln
     für „processing-complete“ bilden das mit dem Präfix nach, damit dabei nichts sichtbar wird. */
@media screen {
  html.farbschema-dunkel .uploader__art {
    filter: grayscale(1) brightness(.8);
  }
  html.farbschema-dunkel .uploader ::v-deep .filepond--item-panel {
    background-color: var(--here);
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state="processing-complete"] .filepond--item-panel {
    background-color: var(--sel);
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="error"] .filepond--item-panel,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="invalid"] .filepond--item-panel {
    background-color: var(--red-t);
  }
  html.farbschema-dunkel .uploader ::v-deep .filepond--file {
    color: var(--ink);
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="error"] .filepond--file,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="invalid"] .filepond--file {
    color: var(--red);
  }
  html.farbschema-dunkel .uploader ::v-deep .filepond--file-info-sub,
  html.farbschema-dunkel .uploader ::v-deep .filepond--file-status-sub {
    opacity: .8;
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="error"] .filepond--file-info-sub,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="error"] .filepond--file-status-sub,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="invalid"] .filepond--file-info-sub,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state*="invalid"] .filepond--file-status-sub {
    opacity: 1;
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state="processing-complete"] .filepond--file-info-sub,
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state="processing-complete"] .filepond--processing-complete-indicator:not([style*="hidden"]) ~ .filepond--file-status .filepond--file-status-sub {
    opacity: 0;
  }
  html.farbschema-dunkel .uploader ::v-deep [data-filepond-item-state="processing-complete"] .filepond--action-revert-item-processing ~ .filepond--file-info .filepond--file-info-sub {
    opacity: .8;
  }
}
</style>
